import { Avatar, Button, Icon } from '@graftcode/design-system'

import { ACADEMY_HEADER_NAV_TEST_IDS } from '@/shared/academy-test-ids.const'

import type { NavbarUserActionsProps } from './types'

import styles from './NavbarUserActions.module.scss'

export function NavbarUserActions({ avatarSrc }: NavbarUserActionsProps) {
  return (
    <div data-testid={ACADEMY_HEADER_NAV_TEST_IDS.userActions}>
      <div className={styles.actions}>
        <Button iconOnly size="m" variant="ghost" icon={Icon.QuestionCircleRegular} aria-label="Help" />
        <div className={styles.notificationBtn}>
          <Button iconOnly size="m" variant="ghost" icon={Icon.AlertRegular} aria-label="Notifications" />
          <span className={styles.badge}>4</span>
        </div>
      </div>
      <div className={styles.avatar}>
        <Avatar size={32} src={avatarSrc} />
      </div>
    </div>
  )
}
